<template>
  <div>
    <van-tabbar
      route
      v-model="active"
      active-color="#FF5402"
      inactive-color="#818181"
      @change="onChange"
      z-index='100'
    >
      <!-- <van-tabbar-item>
      <span>自定义</span>
      <template #icon="props">
        <img :src="props.active ? icon.active : icon.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item icon="search">标签</van-tabbar-item>
    <van-tabbar-item icon="setting-o">标签</van-tabbar-item> -->
      <van-tabbar-item replace to="/home">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active? icon1.active : icon1.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/consulting">
        <span>资讯</span>
        <template #icon="props">
               <img :src="props.active? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item replace  to="/cart">
        <span>购物车</span>
        <template #icon="props">
          <img :src="props.active? icon3.active : icon3.inactive" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item replace  to="/mine">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active? icon4.active : icon4.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      icon1: {
        inactive: "http://jiudaifu-data.oss-cn-hangzhou.aliyuncs.com/web/jiudaifu/common/home.png",
        active: "http://jiudaifu-data.oss-cn-hangzhou.aliyuncs.com/web/jiudaifu/common/home_on.png",
      },
      icon2: {
        inactive: "http://jiudaifu-data.oss-cn-hangzhou.aliyuncs.com/web/jiudaifu/common/ask.png",
        active: "http://jiudaifu-data.oss-cn-hangzhou.aliyuncs.com/web/jiudaifu/common/sak_on.png",
      },
      icon3: {
        inactive: "http://jiudaifu-data.oss-cn-hangzhou.aliyuncs.com/web/jiudaifu/common/cart.png",
        active: "http://jiudaifu-data.oss-cn-hangzhou.aliyuncs.com/web/jiudaifu/common/cart_on.png",
      },
      icon4: {
        inactive: "http://jiudaifu-data.oss-cn-hangzhou.aliyuncs.com/web/jiudaifu/common/mine.png",
        active: "http://jiudaifu-data.oss-cn-hangzhou.aliyuncs.com/web/jiudaifu/common/mine_on.png",
      },
    };
  },
  methods: {
    onChange(e) {
      console.log(e);
    },
  },
};
</script>
<style scoped>
.van-tabbar {
  height: 1rem !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Foot.vue